import { render, staticRenderFns } from "./extra-main.vue?vue&type=template&id=43137c53&scoped=true&lang=pug&"
import script from "./extra-main.vue?vue&type=script&lang=js&"
export * from "./extra-main.vue?vue&type=script&lang=js&"
import style0 from "./extra-main.vue?vue&type=style&index=0&id=43137c53&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43137c53",
  null
  
)

export default component.exports